import i18next from 'i18next';

export const translate = (value: string, props?: object): string => `${i18next.t(value as any, props as any)}`;
